
import './Ujab_board.scss';
import * as S from '../scss/theme';
import fnc from '../mymod/commFunction';
import fncS4 from '../mymod/commFunction4';
import HongButton from '../comm/HongButton';
import React, { useState, useRef, useMemo, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import HeaderTitle from '../comm/HeaderTitle';
import HongComboboxNew from '../comm/HongComboboxNew';
import Ujab_detail from './Ujab_detail'; // 게시글 상세 컴포넌트
import { selectedParentCode_ujab, setSelectedParentCode_ujab } from "../reduxToolkit/reduxIgong"; // Redux 액션 임포트



const Ujab_board = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [listUnit1, setListUnit1] = useState([]);
  const [listUnit2, setListUnit2] = useState([]);
  const [title, setTitle] = useState('알쓸우잡 입력');
  const editor = useRef(null);
  const [content, setContent] = useState(''); // JoditEditor의 내용 상태
  const placeholder = '여기에 내용을 입력하세요.'; // JoditEditor의 플레이스홀더
  const [subject, setSubject] = useState(''); // 주제 입력 상태
  const [writer, setWriter] = useState('');
  const [hp, setHp] = useState('');
  const [email, setEmail] = useState('');
  const [career, setCareer] = useState('');

  const [files, setFiles] = useState({});
  const [fileNames, setFileNames] = useState({});
  const [parentCode, setParentCode] = useState(null);
  const [selectedUnit1, setSelectedUnit1] = useState(null);
  const [selectedUnit2, setSelectedUnit2] = useState(null);
  const [boardList, setBoardList] = useState([]); 
  const [isModal_detail, setIsModal_detail] = useState(false);
  const [selectedCode, setSelectedCode] = useState(null); // 선택된 게시글 코드
  const isAdmin = useSelector((state => state.reduxIgong.isAdmin));

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const unit1_code = params.get('unit1_code') || 'U01';
    const unit2_code = params.get('unit2_code') || 'U0101';
    

    if (unit1_code) {
      setSelectedUnit1(unit1_code);
      fncSelect_list_unit2(unit1_code);
    }
    if (unit2_code) {
      setSelectedUnit2(unit2_code);
      fncSelectBoardList(unit2_code);
    }

    const pcode = fnc.fncSirialNum('p');//여기서 코드 발급
    setParentCode(pcode);

    fncSelect_list_unit1();   
  }, []);




  function fncSelect_list_unit1() {
    fnc.sendAxios('/ujabRoutes/select/unit1', { }, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setListUnit1(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });
  
    function getRecords(res) {
      return res.map(item => ({
        value: item["unit1_code"] ?? '',
        label: item["unit1_name"] ?? '',
        no: item["sort_order"] ?? ''
      }));
    }
  }
  function handleUnit1Change(selectedValue, selectedLabel, selectedItem) {
    if (selectedValue) {
      setSelectedUnit1(selectedValue);
      fncSelect_list_unit2(selectedValue);
    }
  }

  function fncSelect_list_unit2(unit1_code) {
    fnc.sendAxios('/ujabRoutes/select/unit2', {unit1_code}, (res) => {
      if (res && Array.isArray(res)) {
        const newList = getRecords(res);
        setListUnit2(newList);
      } else {
        alert('검색에 실패했습니다.');
      }
    });

    function getRecords(res) {
      return res.map(item => ({
        value: item["unit2_code"] ?? '',
        label: item["unit2_name"] ?? '',
        no: item["sort_order"] ?? ''
      }));
    }
  }

  function handleUnit2Change(selectedValue, selectedLabel, selectedItem) {
    if (selectedValue) {
      setSelectedUnit2(selectedValue);
      fncSelectBoardList(selectedValue)
    }
  }

  // 게시글 목록을 가져오는 함수

  function fncSelectBoardList(unit2_code) {
    fnc.sendAxios('/igongUjabRoutes/select/boardList', {unit2_code}, (res) => {
      if (res && Array.isArray(res)) {
        setBoardList(res);
      } else {
        setBoardList([]);
      }
    });
  }

  function onDetail(item) {
    dispatch(setSelectedParentCode_ujab(item.code)); 
    navigate(`/ujab_detail`); 
  }

  function onBackClick() {
    navigate('/Ad_menu'); 
  }
    
//=========================================
  return (
  <S.Section2>

    <div className='Ujab_board'>
      
      <section className='sec-main'>
         <HeaderTitle title='알쓸우잡' direction={1} onBackClick={onBackClick} />
      <article className='art-unit1'>
        <div className='box-unit1'>
          <HongComboboxNew
            className='h-combobox'
            label=''
            options={listUnit1}
            value={selectedUnit1}
            onChange={handleUnit1Change} 
            placeholder='구분1을 선택하세요.'/>
          
        </div>

        <div className='box-unit2'>
          <HongComboboxNew
            className='h-combobox'
            label=''
            options={listUnit2}
            value={selectedUnit2}
            onChange={handleUnit2Change}
            placeholder='구분2를 선택하세요.'
          />
        </div>

      </article>

      {boardList.length > 0 && (
        <article className="art-boardList">
          <table className="table-hong board-list-table">
            {/* <thead>
              <tr>
                <th>번호</th>
                <th>제목</th>
                <th>글쓴이</th>
                <th>등록일</th>
                <th>선택</th>
              </tr>
            </thead> */}

            <tbody>
              {boardList.map((item, idx) => (
                <tr key={item.sno} onClick={() => onDetail(item)} >
                  <td>{idx + 1}</td>
                  <td>{item.subject}</td>
                  <td>{item.writer}</td>
                  <td>{item.sDate?.substring(0, 10)}</td>
                  {/* <td>
                      <HongButton className='h-btn-gray' onClick={() => onDetail(item)}>선택</HongButton>
                  </td> */}
                  
                </tr>
              ))}
            </tbody>
          </table>
        </article>
      )}

      {isAdmin && <article className='art-menu'>
            <HongButton className='btn h-btn-dark' onClick={()=>navigate('/ujab_write')}>글쓰기</HongButton>
      </article>}
  
    </section>
    </div>

   
  </S.Section2>
  );
};

export default Ujab_board;